import { mySPHOpenLogin } from "@app/util/helpers";
import { PressEvent } from "@react-types/shared";
import Button from "@src/app/components/AccessibleComponents/Button";
import cx from "classnames";

export type LoginTriggerProps = {
  title?: string;
  onToggleLogin?: ((e: PressEvent) => void) | null;
  white?: boolean;
};
// TODO: implement mySPH login: feature/lightbox-https: https://github.com/SPHTech/bt-web/tree/feature/lightbox-https
// https://sph.atlassian.net/browse/NGDP-183
export default function LoginTrigger({
  title = "LOG IN",
  onToggleLogin = null,
  white = false,
}: LoginTriggerProps): React.ReactElement {
  const textColor = white ? "text-white" : "text-gray-850";

  return (
    <Button
      className={cx(
        textColor,
        "cursor-pointer px-2 font-poppins font-semibold uppercase opacity-100",
        "xl:px-3",
        "hover:opacity-75"
      )}
      onPress={(e) => {
        /**
         * @description this function will open up the mysph login lightbox
         * @see https://docs.google.com/document/d/1obM9zIuU0Cj6UlI3mkHXGWDEIAGpCx029iiuV_kEwUU for API usage of window._mySPHObj
         */
        mySPHOpenLogin();

        onToggleLogin && onToggleLogin(e);
      }}
    >
      {title}
    </Button>
  );
}
